import React from 'react';
import Plot from 'react-plotly.js';
import raw_data from './corrData.json';
import {list_choice,list_code,list_country } from './constantData'
import { Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import {Row, Col} from 'antd';

const layout ={width: 900, height: 350,
    margin:{
        l:0,
        r:0,
        b:0,
        t:0,
        pad:0,
    },
    geo:{
        showframe: false,
        showcoastlines: false,
        projection:{
            type: 'scattermapbox'
        },
    }
};


const datatypes =['GDP_Rate','Population_Rate','male_female']
const selections = ['GDP per Capita vs. Suicide Rate', 'Population vs. Suicide Rate', 'Male vs. Female Suicide Rate']
export default class CorrMap extends React.Component{
    constructor(props) {
        super(props);
        this.state = { data: [], layout: layout, frames: [], config: {},map:'',selectedData:'GDP_Rate'};
    }

    componentDidMount(){
        console.log('corrmap')

        // this.setState({layout})
        this.update(this.state.selectedData)
    };

    update=(selectedData=this.state.selectedData)=>{
        //selected data
        var tmp_lo=[];
        var tmp_z= [];
        var tmp_text =[];
        var clean_data =[];
        var arrayLength = raw_data.length;
        for (var i = 0; i < arrayLength; i++) {
                tmp_lo.push(raw_data[i]['code'])
                tmp_z.push(raw_data[i][selectedData])
                tmp_text.push(raw_data[i]['country'])
        }
        //inserting Nan country
        let length = list_code.length;
        for (var i = 0;i<length;i++ ){
            if (tmp_lo.indexOf(list_code[i]) === -1){
                tmp_lo.push(list_code[i])
                tmp_z.push(NaN)
                tmp_text.push(list_country[list_code[i]])
            }
        }

        //format of data
        clean_data = [{
            type: 'choropleth',
            locations: tmp_lo,
            z:tmp_z,
            text:tmp_text,
            zmin: -1,
            zmax: 1,
            colorscale: [
                ['0.0', 'rgb(255, 0, 0)'],
                ['0.111111111111', 'rgb(255, 51, 51)'],
                ['0.222222222222', 'rgb(255, 102, 102)'],
                ['0.333333333333', 'rgb(255, 153, 153)'],
                ['0.444444444444', 'rgb(255, 204, 204)'],
                ['0.5', 'rgb(255, 255, 255)'],
                ['0.555555555556', 'rgb(204, 204, 255)'],
                ['0.666666666667', 'rgb(128, 128, 255)'],
                ['0.777777777778', 'rgb(77, 77, 255)'],
                ['0.888888888889', 'rgb(0, 0, 204)'],
                ['1.0', 'rgb(49,54,149)']
              ],
            colorbar: {
                title: "Correlation Coefficient",
                thickness: 5,
                len:0.5,
            },
            marker: {
                line:{
                    color: 'rgb(255,255,255)',
                    width: 2
                }
            },
        }]
        let map = <Plot
            data={clean_data}
            layout={this.state.layout}
            config={{displayModeBar:false}}
        />
        this.setState({map});
    }


    handleDataSelect=(event)=>{
        const selectedData = datatypes[selections.indexOf(event.target.value)];
        console.log(selectedData);
        this.setState({selectedData});
        this.update(selectedData)
    }

    render(){
        let dataSelect = selections.map((datatype) => {
			return (
				<FormGroup check>
                    <Label check>
                        <Input type="radio" name="Data type" onClick={this.handleDataSelect} value={datatype} defaultChecked={datatype==='GDP per Capita vs. Suicide Rate'} />{' '}
                        {datatype}
                    </Label>
                </FormGroup>
			);
        });

        return (
            <div>
                <Row><h2 style={{textAlign: 'center'}}>Correlation Map ({selections[datatypes.indexOf(this.state.selectedData)]})</h2></Row>
                <Row>
                    <Col span={2}></Col>
                    <Col span={16}>{this.state.map}</Col>
                    <Col span={6}>{dataSelect}</Col>
                </Row>
            </div>
        );}

}